import { useState } from 'react';
import { MessageMedium } from 'constants/messageMediums';
import { SuggestionCard } from 'modules/ai/nba/components/previewSuggestion/SuggestionCard';
import { createMediumContentUpdate } from 'modules/ai/nba/utils/transformTemplate';
import { getSelectedSuggestion } from 'modules/ai/nba/utils/recommendedContents';
import { UpdateMediumFieldsType } from 'modules/templateEditor/common';
import { useTemplateTakeover } from 'modules/templateEditor/integrations/InStudioTemplateEditing/context/TemplateTakeoverContext';
import { PaddedFormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';

// for testing
const suggestions = [
  {
    suggestionText: 'Need to cool off? Swing by and beat the heat with our sweet, icy treats!',
    moodText: 'Cheerful with a hint of suggestion',
  },
  {
    suggestionText:
      "We'll help you beat the heat, one scoop at a time. Swing by after work and cool down with our delicious treats! See you soon!",
    moodText: 'Friendly and inviting with a call to action',
  },
  {
    suggestionText: 'You deserve something special. Swing by for a sweet treat!',
    moodText: 'Upbeat, positive, and persuasive',
  },
];

export interface NBASectionProps {
  messageMedium: MessageMedium;
  onPreviewClick: (suggestedContent: UpdateMediumFieldsType) => void;
}

export const NBASection = ({ messageMedium, onPreviewClick }: NBASectionProps) => {
  const takeover = useTemplateTakeover();

  const [selectedValue, setSelectedValue] = useState<string>('0');

  const handleSetSuggestion = (suggestionIdx: string) => {
    setSelectedValue(suggestionIdx);
  };

  const handleOnPreviewClick = () => {
    const suggestedText = getSelectedSuggestion(suggestions, selectedValue)?.suggestionText;
    onPreviewClick(createMediumContentUpdate(messageMedium, suggestedText));
    takeover.open(takeover.viewOptions.settings);
  };

  return (
    <PaddedFormSectionContent>
      <SuggestionCard
        messageMedium={messageMedium}
        onSetSuggestion={handleSetSuggestion}
        onPreviewClick={handleOnPreviewClick}
        selectedSuggestion={selectedValue}
      />
    </PaddedFormSectionContent>
  );
};
